
seedWebServices.service('DatabaseService', ['$resource', '$http', '$cacheFactory', function ($resource, $http, $cacheFactory) {

    var serviceCache = $cacheFactory('Database');
    var URL = '../API/Database/'

    
    this.getCopyScript = function (tableName) {
        var cache = serviceCache;
        return $http.put(URL + 'GetCopyScript', 
            { tableName: tableName },
            { cache: cache }
        );
    };


    this.getCopyScripts = function (tables) {
        var cache = serviceCache;
        return $http.put(URL + 'GetCopyScripts',
            { tables: tables },
            { cache: cache }
        );
    };


    this.trackOrder = function (filterString) {
        var cache = serviceCache;
        return $http.put(URL + 'TrackOrder',
            { filterString: filterString },
            { cache: cache }
        );
    };


    this.resetCache = function () {
        serviceCache.removeAll();
    };

    


}]);
